module.exports = __webpack_public_path__ + "static/usage-38a7bda45a14b9c6fd78de4afc11b03f.png";